<template>
  <header id="fisMasthead" class="fisMasthead">
    <div style="display: table-row">
      <div id="fisFacNav-fisMasthead" class="fisFacNav">
        <span class="fisNavItem">
          <span class="hideMedium">{{ application.name }}</span>
          <span class="hideOverMedium">{{ application.acronym }}</span>
        </span>
      </div>
      <div id="fisAppNav-fisMasthead" class="fisAppNav">
        <router-link
          v-for="link in application.links"
          :to="link.routerLink"
          :key="link.id"
          class="fisNavItem"
          data-toggle="tooltip"
          title="Labor"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-clipboard-pulse"
            viewBox="0 0 16 16"
          >
            <path
              v-for="svg in link.svgs"
              :key="svg.id"
              fill-rule="evenodd"
              :d="svg.svg"
            />
          </svg>
          <span class="hideSmall fisNavDescription">{{ link.name }}</span>
          <!--        </a>-->
        </router-link>
      </div>
      <div id="fisUser-fisMasthead" class="fisUser fisNavItem">
        <template v-if="mutable">
          <a
            id="impersonate-fisUser-fisMasthead"
            href="#"
            class="clickable"
            @click="toggleImpersonate()"
          >
            <span
              id="fullName-fisUser-fisMasthead"
              class="fisDarkBlue hideMedium"
              >{{ user.fullName }} ~
            </span>
            <span id="netId-fisUser-fisMasthead" class="fisDarkBlue hideSmall"
              >{{ user.netId }} :
            </span>
            <span
              id="instance-fisUser-fisMasthead"
              class="fisDarkBlue"
              :class="production() ? 'FAM1' : 'FAM2'"
              >{{ user.instance }}</span
            >
          </a>
        </template>
        <template v-else>
          <span id="fullName-fisUser-fisMasthead" class="fisDarkBlue hideMedium"
            >{{ user.fullName }} ~
          </span>
          <span id="netId-fisUser-fisMasthead" class="fisDarkBlue hideSmall"
            >{{ user.netId }} :
          </span>
          <span
            id="instance-fisUser-fisMasthead"
            class="fisDarkBlue"
            :class="production() ? 'FAM1' : 'FAM2'"
            >{{ user.instance }}</span
          >
        </template>
      </div>
      <div
        v-show="showImpersonate"
        id="impersonate-div"
        class="impersonate-div"
        :style="impersonateStyle"
      >
        <div class="">
          <span class="popTitle">Impersonate</span
          ><span class="float-end"
            ><a href="#" onclick="return false;" @click="toggleImpersonate"
              >X</a
            >
          </span>
        </div>
        <div class="input-group input-group-sm">
          <input
            id="impersonate-input"
            class="impersonate-input"
            v-model="impersonateWho"
            v-on:keyup.enter="impersonate"
          />
          <button
            id="impersonate-btn "
            class="btn btn-warning"
            @click="impersonate"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'fisMasthead',
  emits: ['impersonateUser'],
  props: {},
  data() {
    return {
      showImpersonate: false,
      impersonateStyle: { position: 'absolute', top: '66px', left: '66px' },
    };
  },
  computed: {
    ...mapGetters(['application', 'user', 'token', 'impersonateNetId']),
    impersonateWho: {
      get() {
        return this.impersonateNetId;
      },
      set(value) {
        this.$store.commit('impersonateNetId', value);
      },
    },
    mutable: {
      get() {
        if (this.user.mutable) return true;
        return false;
      },
    },
  },
  methods: {
    production() {
      if (this.user.instance == 'yaleaimprod') {
        // alert(`${this.user.instance} == 'FAM1'`);
        return true;
      } return false;
    },
    impersonate() {
      this.toggleImpersonate();
      this.$emit('impersonateUser');
    },
    toggleImpersonate() {
      if (this.showImpersonate) this.showImpersonate = false;
      else {
        const element = document.getElementById(
          'impersonate-fisUser-fisMasthead',
        );
        this.impersonateStyle.left = `${element.offsetLeft}px`;
        this.impersonateStyle.top = `${element.offsetTop + 25}px`;
        this.showImpersonate = true;
      }
    },
  },
};
</script>

<style scoped>
.popTitle {
  color: #000000;
}
.impersonate-input {
  max-width: 6rem;
}
.impersonate-div {
  position: absolute !important;
  z-index: 4000 !important;
  background-color: white;
  border: solid black 1px;
  border-radius: 2px;
  padding: 1rem;
}

</style>
